import script from "./EditCompany.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCompany.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__